import { useState } from 'react';

import { useLazyQuery } from '@apollo/client';

import { GET_AGREEMENT_DOCUMENT_PDF } from 'src/graphql/queries/getAgreementDocuments.query';
import { getFileNameFromDownloadLink, onError } from 'src/utils/utils';

export function useAdobeSignDocument() {
    const [pdfFile, setPdfFile] = useState<File | null>();
    const [isPDFModalOpen, setIsPDFModalOpen] = useState(false);
    const [adobeDocumentPdf, setAdobeDocumentPdf] = useState<{
        downloadLink: string;
        pdfBytes: string;
    } | null>();

    const [getAgreementDocumentPdfQuery, { loading: loadingAgreementDocumentPdf }] = useLazyQuery(
        GET_AGREEMENT_DOCUMENT_PDF,
        {
            fetchPolicy: 'network-only',
            onError,
            onCompleted: (data) => {
                setAdobeDocumentPdf(data?.getAdobeSignDocumentPdf);

                const file = new File(
                    [data?.getAdobeSignDocumentPdf?.downloadLink],
                    getFileNameFromDownloadLink(data?.getAdobeSignDocumentPdf?.downloadLink),
                    {
                        type: 'application/pdf',
                    }
                );

                setPdfFile(file);

                setIsPDFModalOpen(true);
            },
        }
    );

    const getAdobeSignDocumentPdf = ({ documentId, agreementId }) => {
        getAgreementDocumentPdfQuery({
            variables: {
                input: {
                    documentId,
                    agreementId,
                },
            },
        });
    };

    return {
        getAdobeSignDocumentPdf,
        adobeDocumentPdf,
        isPDFModalOpen,
        setIsPDFModalOpen,
        pdfFile,
        loadingAgreementDocumentPdf,
    };
}
